import React, { useRef, useMemo } from 'react';
import useGlossary from './../hooks/useGlossary';

const TextModule = (props) => {
  const textRef = useRef();
  const { text, glossaryUrl } = props;

  // merge glossary words with tippy - WARN - this is outside of react but manages via events on the textRef
  const updatedText = useGlossary(text, textRef, glossaryUrl);

  // {__html: updatedText} is a new object on every render, so without
  // memoizing it, React sees a "changed" prop on every unrelated re-render
  // and rewrites the DOM, wiping out the glossary-wrapper/tippy setup
  // useGlossary already attached.
  const htmlProp = useMemo(() => ({ __html: updatedText }), [updatedText]);

  return <div ref={textRef} className="detailPage__text" dangerouslySetInnerHTML={htmlProp} />;
};

export default TextModule;
